<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="searchSuggestion.attributes"
          headline="Edit Search Suggestion"
          :errors="errors"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/SearchSuggestions/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      searchSuggestion: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/search-suggestions/' + this.$route.params.searchSuggestionId).then(response => {
        this.searchSuggestion = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/search-suggestions/' + this.$route.params.searchSuggestionId, data)
          .then(response => {
            notify.success('The search suggestion was saved')

            this.searchSuggestion = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
